import axios from 'axios'
import { baseURLV1 } from '../../../service/API'

export const LOGIN_URL = `${baseURLV1}/auth/login`
export const ME_URL = `${baseURLV1}/auth/me`
export const MFA_PENDING_KEY = 'mfaPendingToken'

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password })
}

export function mfaHeaders() {
  const token = sessionStorage.getItem(MFA_PENDING_KEY)
  return {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  }
}

export function mfaEnrollSetup() {
  return axios.post(`${baseURLV1}/auth/mfa/enroll/setup`, {}, { headers: mfaHeaders() })
}

export function mfaEnrollVerify(code) {
  return axios.post(`${baseURLV1}/auth/mfa/enroll/verify`, { code }, { headers: mfaHeaders() })
}

export function mfaVerify(code) {
  return axios.post(`${baseURLV1}/auth/mfa/verify`, { code }, { headers: mfaHeaders() })
}

export function getUserByToken() {
  let token = localStorage.getItem('Token')
  return axios({
    method: 'post',
    url: ME_URL,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
}

export function resetStaffMfa(id) {
  const token = localStorage.getItem('Token')
  return axios.post(
    `${baseURLV1}/user/${id}/mfa/reset`,
    {},
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
}
